import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function Main2019V2() {
  const handleDownload1 = () => {
    window.open("assets/2019/V2/C Lalnunmawia & Lalhriatpuii.pdf", "_blank");
  };
  const handleDownload2 = () => {
    window.open("assets/2019/V2/James L.T. Thanga.pdf", "_blank");
  };
  const handleDownload3 = () => {
    window.open("assets/2019/V2/Rohmingliani.pdf", "_blank");
  };
  const handleDownload4 = () => {
    window.open("assets/2019/V2/Lalzuiliana.pdf", "_blank");
  };
  const handleDownload5 = () => {
    window.open("assets/2019/V2/Lalchhuanmawia.pdf", "_blank");
  };
  const handleDownload6 = () => {
    window.open("assets/2019/V2/Lianzela.pdf", "_blank");
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className=" h-full justify-center items-center flex mx-20">
        <div className="flex flex-col-reverse lg:flex-row  justify-center items-center">
          {/* Book Cover */}
          <div className=" mr-20 sm:mt-0 md:mt-20 mt-20 flex flex-col justify-center items-center">
            <img className="h-96 w-60" src="mea.webp" />
            <div className=" text-center font-semibold">ISSN 2581-7523</div>
          </div>
          {/* Main Page */}
          <div className="">
            <div className="">
              <div className=" font-bold text-xl">Mizoram Economic Review</div>
              <div className="text-sm">Volume 2, No. 2 (2019)</div>
              <div className="text-sm">ISSN 2581-7523</div>
            </div>

            {/* Content */}
            <div className="mt-10 grid grid-row-1 gap-6">
              <button className="text-left" onClick={handleDownload1}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Multidimensional Poverty: A Village-Wise Study of Tlangnuam
                  Block, Mizoram
                </div>
                <div className="text-sm text-green-600">
                  C. Lalnunmawia & Lalhriatpuii
                </div>
              </button>
              <button className="text-left" onClick={handleDownload2}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Institutional Changes in Jhum Land Tenure System in Mizoram
                </div>
                <div className="text-sm text-green-600">James L.T. Thanga</div>
              </button>
              <button className="text-left" onClick={handleDownload3}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Viability of Anthurium Cultivation in Mizoram
                </div>
                <div className="text-sm text-green-600">Rohmingliani</div>
              </button>
              <button className="text-left" onClick={handleDownload4}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Veterinary Healthcare Services Delivery System: A Study
                </div>
                <div className="text-sm text-green-600">Lalzuiliana</div>
              </button>
              <button className="text-left" onClick={handleDownload5}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  An assessment of the Contribution of Agricultural Sector in
                  Mizoram Economy
                </div>
                <div className="text-sm text-green-600">Lalchhuanmawia</div>
              </button>
              <button className="text-left" onClick={handleDownload6}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Industrial Sector of Mizoram
                </div>
                <div className="text-sm text-green-600">Lianzela</div>
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
